import product from 'assets/core/js/entry/product'
import GoTop from 'assets/core/js/module/goTop'
import HashManager from 'assets/core/js/module/hashManager'
import lastSeen from 'assets/core/js/module/lastSeen'
import dataLayer from 'assets/core/js/page/product/dataLayer'
import goBack from 'assets/core/js/page/product/goBack'
import presentation from 'assets/core/js/page/product/presentation'
import reviewComment from 'assets/core/js/page/product/review/comment'
import facets from 'assets/core/js/page/product/search/facets'
import zoomMediasPanel from 'assets/core/js/page/product/zoomMediasPanel'
import faqToggle from 'assets/themes/vacances-campings/js/module/faqToggle'
import partials from 'assets/themes/vacances-campings/js/module/partials'
import bestOffer from 'assets/themes/vacances-campings/js/page/product/bestOffer'
import calendar from 'assets/themes/vacances-campings/js/page/product/calendar'
import imagesSliders from 'assets/themes/vacances-campings/js/page/product/imagesSliders'
import shareModal from 'assets/themes/vacances-campings/js/page/product/modal/share'
import properties from 'assets/themes/vacances-campings/js/page/product/properties'
import results from 'assets/themes/vacances-campings/js/page/product/results'
import pagination from 'assets/themes/vacances-campings/js/page/product/reviews/pagination'
import sorting from 'assets/themes/vacances-campings/js/page/product/reviews/sorting'
import toggle from 'assets/themes/vacances-campings/js/page/product/reviews/toggle'
import tripadvisor from 'assets/themes/vacances-campings/js/page/product/reviews/tripadvisor'
import scrollToTarget from 'assets/themes/vacances-campings/js/page/product/scrollToTarget'
import search from 'assets/themes/vacances-campings/js/page/product/search'
import sidePanels from 'assets/themes/vacances-campings/js/page/product/sidePanels'

const productFacets = facets.init()
HashManager.init()

document.addEventListener('DOMContentLoaded', function () {
  // must be called before search
  partials()
  /**
   * @TODO: Migrate all core components to the core/js/entry/product entry.
   */
  product()

  sidePanels.init()
  search(productFacets)

  GoTop('.top__block')
  faqToggle()

  bestOffer()
  imagesSliders()
  dataLayer('.result__card[data-id]')
  goBack()
  scrollToTarget()
  calendar()
  zoomMediasPanel()
  pagination()
  sorting()
  toggle()
  tripadvisor()
  properties()
  shareModal()
  reviewComment()
  results()
  presentation()
  lastSeen()
})
